import { PaletteColor } from '@mui/material'

declare module '@mui/material/styles' {
	interface Palette {
		gameRoundRobin: Palette['primary']
	}

	interface PaletteOptions {
		gameRoundRobin?: PaletteOptions['primary']
	}
}

declare module '@mui/material/Alert' {
	interface AlertPropsColorOverrides {
		gameRoundRobin: true
	}
}

export const gameRoundRobinColor = {
	main: '#BB2C9C',
	light: '#FFE8EE',
} as PaletteColor
